import { useEffect, useState } from "react";
import {
  Typography,
  Divider,
  Form,
  Tree,
  Input,
  Empty,
  Button,
  Collapse,
  Tooltip,
  Slider,
  // Tag,
} from "antd";
import {
  convertCategoriesToTreeNodes,
  remainingViewportHeight,
} from "../../../components/icons/ApplicationColor";
import {
  CloseOutlined,
  FilterOutlined,
  InteractionTwoTone,
  SearchOutlined,
  CaretDownOutlined,
  DownOutlined,
  RightOutlined,
} from "@ant-design/icons";
import CourseFilterHelper from "./CourseFilterHelper";
// import { duration } from "moment";
const { Panel } = Collapse;
const CourseFiltersSplitter = ({
  form,
  handleDecodedFormValues,
  setShowFilter,
  handleClearAll,
  classifications,
  languages,
  categories,
  modes,
  tags,
  producers,
  categorySearch,
  setCategorySearch,
  checkedKeys,
  handleCheck,
  filter_url,
  origin,
}) => {
  const [filterVisibility, setFilterVisibility] = useState({
    language: false,
    state: true,
    mode: false,
    categories: true,
    source_app: false,
    tag: false,
    producer: false,
    duration: false,
  });
  const toggleFilter = (key) => {
    console.log(key);
    setFilterVisibility((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  // const isInitialized = useRef(false);

  useEffect(() => {
    if (!filter_url) return;

    const searchParams = new URLSearchParams(
      filter_url.split("?")[1] || filter_url
    );

    const initialValues = {};
    searchParams.forEach((value, key) => {
      const valArray = value.includes(",")
        ? value.split(",").map((v) => v.trim())
        : [value.trim()];
      initialValues[key] = valArray;
    });

    console.log("Parsed initial values from URL:", initialValues);
    form.setFieldsValue(initialValues); // Values are now always arrays
  }, [filter_url, form]);

  const durationIndexToMinutes = {
    0: 1,
    1: 30,
    2: 60,
    3: 300,
    4: 600,
    5: 1800,
  };
  const getDurationValue = (durationArray) => {
    if (
      !durationArray ||
      durationArray.length !== 2 ||
      (durationArray[0] === 0 && durationArray[1] === 0)
    ) {
      return null;
    }

    return [
      durationIndexToMinutes[durationArray[0]],
      durationIndexToMinutes[durationArray[1]],
    ];
  };
  const resetFilters = () => {
    form.resetFields(); // Clears all fields
    handleClearAll();
  };
  const handleClearFilter = (fieldName) => {
    // Clear the selected field
    form.setFieldsValue({ [fieldName]: [] });

    // Get all form values and process duration
    const allValues = form.getFieldsValue();
    const processedDuration = getDurationValue(allValues.duration);

    // Build the final payload
    const finalPayload = {
      ...allValues,
      duration: processedDuration,
    };

    // Trigger your existing function
    handleDecodedFormValues(finalPayload);
  };
  return (
    <div
      style={{
        background: "#f0f2f5",
        padding: "0.75rem",
        margin: 0,
        borderRight: "1px solid #d9d9d9",
        height: `${remainingViewportHeight(14)}px`,
        overflowY: "auto",
      }}
    >
      <Form
        form={form}
        layout="vertical"
        onValuesChange={(_, allValues) => {
          console.log(allValues);
          const processedDuration = getDurationValue(allValues.duration);
          const finalPayload = {
            ...allValues,
            duration: processedDuration,
          };
          handleDecodedFormValues(finalPayload);
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginInline: "7.5px",
            marginLeft: "10px",
            marginTop: "7.5px",
            marginBottom: "17.5px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <FilterOutlined style={{ fontSize: 17 }} />
            <Typography.Title level={5} style={{ margin: 0 }}>
              Apply Filters
            </Typography.Title>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {filter_url && (
              <Tooltip title="Clear All Filters">
                <InteractionTwoTone
                  onClick={resetFilters}
                  // twoToneColor="#ff4d4f"
                  style={{ fontSize: 21, cursor: "pointer" }}
                />
              </Tooltip>
            )}
            <Tooltip title="Close Filter Panel">
              <CloseOutlined
                onClick={() => setShowFilter(false)}
                style={{ fontSize: 16, cursor: "pointer" }}
              />
            </Tooltip>
          </div>
        </div>

        {origin === "TN_ADMIN" && (
          <>
            <Divider style={{ marginTop: 10, marginBottom: 10 }} />

            <CourseFilterHelper
              title="Source Module"
              name="source_app"
              items={classifications}
              valueKey="classification"
              labelKey="classification"
              form={form}
              showClear={true}
              onClear={() => handleClearFilter("source_app")}
              isVisible={filterVisibility.source_app}
              toggle={toggleFilter}
            />
            <Divider style={{ marginTop: 10, marginBottom: 10 }} />

            <CourseFilterHelper
              title="Producers"
              name="producer"
              items={producers}
              valueKey="id"
              labelKey="name"
              form={form}
              showClear={true}
              onClear={() => handleClearFilter("producer")}
              isVisible={filterVisibility.producer}
              toggle={toggleFilter}
            />
          </>
        )}

        <Divider style={{ marginTop: 10, marginBottom: 10 }} />

        <CourseFilterHelper
          title="Languages"
          name="language"
          items={languages}
          valueKey="Language"
          labelKey="Language"
          form={form}
          showClear={true}
          onClear={() => handleClearFilter("language")}
          isVisible={filterVisibility.language}
          toggle={toggleFilter}
        />

        <Divider style={{ marginTop: 10, marginBottom: 10 }} />

        <CourseFilterHelper
          title="Modes"
          name="mode"
          items={modes}
          valueKey="mode"
          labelKey="mode"
          form={form}
          showClear={true}
          onClear={() => handleClearFilter("mode")}
          isVisible={filterVisibility.mode}
          toggle={toggleFilter}
        />

        <Divider style={{ marginTop: 10, marginBottom: 10 }} />
        <CourseFilterHelper
          title="Tags"
          name="tag"
          items={tags}
          valueKey="name"
          labelKey="name"
          form={form}
          showClear={true}
          onClear={() => handleClearFilter("tag")}
          isVisible={filterVisibility.tag}
          toggle={toggleFilter}
        />
        <Divider style={{ marginTop: 10, marginBottom: 10 }} />
        <div style={{ marginInline: 10 }}>
          <div
            className="splitter-first-div"
            onClick={() => toggleFilter("duration")}
            style={{ cursor: "pointer" }}
          >
            <Typography.Text
              className="my-form-lables"
              style={{ margin: 0, padding: 0, paddingInline: "5px" }}
            >
              Duration
            </Typography.Text>
            <Button
              type="text"
              icon={
                filterVisibility.duration ? <DownOutlined /> : <RightOutlined />
              }
              size="small"
            />
          </div>
          <Collapse
            activeKey={filterVisibility.duration ? ["1"] : []}
            ghost
            style={{ margin: 0, padding: 0 }}
          >
            <Panel key="1" showArrow={false} style={{ margin: 0, padding: 0 }}>
              <Form.Item name="duration" style={{ margin: 0 }}>
                <Slider
                  range
                  min={0}
                  max={5}
                  step={null}
                  marks={{
                    0: "1m",
                    1: "30m",
                    2: "1h",
                    3: "5h",
                    4: "10h",
                    5: "30h+",
                  }}
                  tipFormatter={(val) => {
                    switch (val) {
                      case 0:
                        return "1m";
                      case 1:
                        return "30m";
                      case 2:
                        return "1h";
                      case 3:
                        return "5h";
                      case 4:
                        return "10h";
                      case 5:
                        return "30h+";
                      default:
                        return val;
                    }
                  }}
                  style={{
                    margin: "10px",
                    marginBottom: "25px",
                  }}
                />
              </Form.Item>
            </Panel>
          </Collapse>
        </div>

        <Divider style={{ marginTop: 10, marginBottom: 10 }} />
        <div style={{ marginInline: 0 }}>
          <div
            className="splitter-first-div"
            onClick={() => toggleFilter("categories")}
          >
            <Typography.Text
              className="my-form-lables"
              style={{ marginInline: 10, padding: 0, paddingInline: "5px" }}
            >
              Categories
            </Typography.Text>

            <Button
              type="text"
              icon={
                filterVisibility.categories ? (
                  <DownOutlined />
                ) : (
                  <RightOutlined />
                )
              }
              size="small"
              style={{ marginInline: 10 }}
            />
          </div>
          <Collapse
            activeKey={filterVisibility?.categories ? ["1"] : []}
            ghost
            style={{ margin: 0, padding: 0 }}
          >
            <Panel key="1" showArrow={false} style={{ margin: 0, padding: 0 }}>
              <Input
                placeholder="Search Categories"
                value={categorySearch}
                onChange={(e) => setCategorySearch(e.target.value)}
                allowClear
                suffix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                style={{ marginTop: 5, marginBottom: 10 }}
              />
              {categories?.length > 0 ? (
                <Form.Item name="categories" style={{ margin: 0 }}>
                  <Tree
                    treeData={convertCategoriesToTreeNodes(
                      categories || [],
                      categorySearch
                    ).map((node) => ({
                      ...node,
                      title: (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <span
                            style={{
                              textOverflow: "ellipsis",
                            }}
                          >
                            {node.title}
                          </span>
                          <span
                            style={{
                              marginLeft: "auto",
                              textAlign: "right",
                              paddingLeft: 10,
                              fontSize: 12,
                              color: "#899499",
                              fontWeight: 600,
                              letterSpacing: 0.5,
                            }}
                          >
                            {node.count !== undefined
                              ? node.count
                              : Math.floor(Math.random() * 100)}
                          </span>
                        </div>
                      ),
                    }))}
                    checkable
                    style={{
                      padding: "5px",
                      maxHeight:
                        origin === "TN_ADMIN"
                          ? "calc(100vh - 78vh)"
                          : "calc(100vh - 74vh)",
                      overflowY: "auto",
                    }}
                    selectable={false}
                    showLine={true}
                    switcherIcon={<CaretDownOutlined />}
                    checkedKeys={checkedKeys}
                    onCheck={handleCheck}
                  />
                </Form.Item>
              ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              )}
            </Panel>
          </Collapse>
        </div>

        <Divider style={{ marginTop: 10, marginBottom: 10 }} />
      </Form>
    </div>
  );
};

export default CourseFiltersSplitter;

// eslint-disable-next-line no-lone-blocks
{
  /* <div style={{ marginInline: 10 }}>
          <div
            className="splitter-first-div"
            onClick={() => toggleFilter("modes")}
          >
            <Typography.Text
              className="my-form-lables"
              style={{ margin: 0, padding: 0, paddingInline: "5px" }}
            >
              Modess
            </Typography.Text>
            <div>
              {form.getFieldValue("mode")?.length > 0 && (
                <Tooltip title="Clear Modes">
                  <CloseCircleTwoTone
                    style={{
                      cursor: "pointer",
                      fontSize: 16,
                      marginRight: 2.5,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      form.setFieldsValue({ mode: [] });
                      const allValues = form.getFieldsValue();
                      const processedDuration = getDurationValue(
                        allValues.duration
                      );
                      const finalPayload = {
                        ...allValues,
                        duration: processedDuration,
                      };
                      handleDecodedFormValues(finalPayload);
                    }}
                  />
                </Tooltip>
              )}
              <Button
                type="text"
                icon={
                  filterVisibility.modes ? <DownOutlined /> : <RightOutlined />
                }
                size="small"
              />
            </div>
          </div>
          <Collapse
            activeKey={filterVisibility.modes ? ["1"] : []}
            ghost
            style={{ margin: 0, padding: 0 }}
          >
            <Panel key="1" showArrow={false} style={{ margin: 0, padding: 0 }}>
              <Form.Item name="mode" style={{ margin: 0 }}>
                <Checkbox.Group>
                  <Row gutter={[16, 8]} style={{ marginTop: 0 }}>
                    {mode
                      ?.filter((lang) => lang.count > 0)
                      ?.map((lang, index) => (
                        <Col
                          key={index}
                          span={24}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox value={lang.mode}>{lang.mode}</Checkbox>
                          <span
                            style={{
                              fontSize: 12,
                              color: "#899499",
                              fontWeight: 600,
                              letterSpacing: 0.5,
                            }}
                          >
                            {lang.count !== undefined ? lang.count : 0}
                          </span>
                        </Col>
                      ))}
                  </Row>
                </Checkbox.Group>
              </Form.Item>
            </Panel>
          </Collapse>
        </div> */
}
